export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://afupunrzk3.execute-api.eu-west-1.amazonaws.com/latest";
